import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { t } from "i18next";
import { Navbar } from "../components/Navbar/Navbar";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import Footer from "../components/Footer/Footer";
import i18next from "i18next";

const currentLang = i18next.language;
const lang = i18next.language;
const reportCards = [
  {
    year: 2024,
    url1: "/files/report-2024.pdf",          // перша кнопка
    url2: `/files/audit-2024-${lang}.pdf` // друга кнопка
  },
  {
    year: 2023,
    url1: "/files/report-2023.pdf",
    url2: `/files/audit-2023-${lang}.pdf`
  },
  {
    year: 2022,
    url1: "/files/report-2022.pdf",
    url2: `/files/audit-2022-${lang}.pdf`
  },
];
const yourButtonStyle = {
  backgroundColor: "#e7f6ff",
  color: "#000",
  padding: "10px 16px",
  borderRadius: "4px",
  display: "inline-block",
  fontWeight: "900",
  fontSize: "2rem",
  cursor: "pointer",
};

export const Reportsfin = () => { 
  return (
    <div className="ReportsPage">
      <Navbar color="menu-wrap" />
      <Container>
        <h1 className="mb-4 mt-4 fw-bold" style={{ color: "#4c94ff" }}>
          {t("reportsfin title")}
        </h1>
        <Row className="g-4">
          {reportCards.map((card, idx) => (
            <Col key={idx} xs={12} md={6}>
              <div
                className="report-card p-5 h-100 d-flex flex-column justify-content-between"
                onClick={() => window.open(card.url, "_blank")}
              >
                <div>
                  <div className="emoji mb-3" style={{ fontSize: "2rem" }}>
                  <div className="logo-menu">
                              <Link to="/">
                                <img src={logo} alt="logo"></img>
                              </Link>
                            </div>
                  </div>
                  <h3 className="fw-bold mb-4" style={{ fontSize: "3rem", lineHeight: 1.4 }}>
                    {t("reportsfin name")}
                  </h3>
                </div>
                <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
                  <span
                    style={yourButtonStyle}
                    onClick={() => window.open(card.url1, "_blank")}
                  >
                    {t("reportsfin22")} {card.year}
                  </span>
                  <span
                    style={yourButtonStyle}
                    onClick={() => {
                      const buttonText = t("reportsfin23");
                      const file =
                        buttonText === "Фінансовий аудит" // або точний український варіант
                          ? `/files/audit-${card.year}-ua.pdf`
                          : `/files/audit-${card.year}-en.pdf`;
                  
                      window.open(file, "_blank");
                    }}
                  >
                    {t("reportsfin23")} {card.year}
                  </span>
                </div>
                
              </div>
              
            </Col>
            
          ))}
        </Row>
      </Container>
      <Footer />
      <style>
        {`
          .report-card {
            background-color: #002f5e;
            color: #fff;
            border-radius: 8px;
            cursor: pointer;
            padding: 40px;
            transition: background-color 0.2s ease;
            min-height: 250px;
          }

          .report-card:hover {
            background-color: #014b91;
          }
            
        `}
      </style>
    </div>
  );
}